import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    user: null,
  }),
  getters: {
    isLoggedIn: (state) => !!state.user,
    // Permission check against the permissions /api/me returned (e.g. "risks.edit").
    can: (state) => (permission) =>
      !!state.user?.permissions?.includes(permission),
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    clearUser() {
      this.user = null;
    },
  },
});
